<template>
    <div v-if="loading" class="flex justify-center items-center h-64">
      <div class="text-gray-500">Loading...</div>
    </div>

    <div v-else>

<div class="grid grid-cols-3 gap-4">
      <div class="bg-white text-center p-6 rounded shadow">
        <span class="text-gray-400 museo-sans-normal">Total Tokens Uploaded</span>
        <p class="text-black font-bold text-center">{{ dashboardTotals.total_uploaded }}</p>
      </div>
      <div class="bg-white text-center p-6 rounded shadow">
        <span class="text-gray-400 museo-sans-normal">Awarded Tokens</span>
        <p class="text-black font-bold text-center">{{ dashboardTotals.total_awarded }}</p>
      </div>
      <div class="bg-white text-center p-6 rounded shadow">
        <span class="text-gray-400 museo-sans-normal">Available Tokens</span>
        <p class="text-black font-bold text-center">{{ dashboardTotals.total_available }}</p>
      </div>
    </div> 
    <table class="w-full text-left text-gray-700 mt-5">
      <thead>
        <tr class="bg-gray-100 ">
          <th scope="col" class="px-3 py-2">
            <div class="text-gray-600 museo-sans-bold">
              Assessment Name
            </div>
          </th>
          <th scope="col" class="px-3 py-2">
            <div class="text-gray-600 museo-sans-bold">
              Total Tokens
             
            </div>
          </th>
          <th scope="col" class="px-3 py-2">
            <div class="text-gray-600 museo-sans-bold">
              Awarded Tokens
            </div>
          </th>
          <th scope="col" class="px-3 py-2">
            <div class="text-gray-600 museo-sans-bold">
              Available Tokens
            </div>
          </th>
          <th scope="col" class="px-3 py-2">
            <div class="text-gray-600 museo-sans-bold">
                CPD Points
            </div>
          </th>
          <th scope="col" class="px-3 py-2">
            <div class="text-gray-600 museo-sans-bold">
              Action
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="assessment in assessments" :key="assessment.assessment_id" class="border-b">
          <td class="px-3 py-2 museo-sans-normal">{{ assessment.assessment_name }}</td>
          <td class="px-3 py-2 museo-sans-normal">{{ assessment.total_tokens }}</td>
          <td class="px-3 py-2 museo-sans-normal">{{ assessment.awarded_tokens }}</td>
          <td class="px-3 py-2 museo-sans-normal">{{ assessment.available_tokens }}</td>
          <td class="px-3 py-2 museo-sans-normal">{{ assessment.cpd_points }}</td>
          <td class="px-3 py-2 museo-sans-normal">
          <div class="flex space-x-2">
            <a
              href="https://jiji-bucket.blr1.cdn.digitaloceanspaces.com/courses/tokens_sample.xlsx"
              download
              target="_blank"
              class="inline-block"
            >
            <button
              
              class="bg-custom-yellow text-white px-3 py-1 rounded flex text-sm museo-sans-normal"
            >
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M19.35 10.54C18.67 7.09 15.64 4.5 12 4.5C9.11 4.5 6.6 6.14 5.35 8.54C2.34 8.86 0 11.41 0 14.5C0 17.81 2.69 20.5 6 20.5H19C21.76 20.5 24 18.26 24 15.5C24 12.86 21.95 10.72 19.35 10.54ZM19 18.5H6C3.79 18.5 2 16.71 2 14.5C2 12.45 3.53 10.74 5.56 10.53L6.63 10.42L7.13 9.47C8.08 7.64 9.94 6.5 12 6.5C14.62 6.5 16.88 8.36 17.39 10.93L17.69 12.43L19.22 12.54C20.78 12.64 22 13.95 22 15.5C22 17.15 20.65 18.5 19 18.5ZM13.45 10.5H10.55V13.5H8L12 17.5L16 13.5H13.45V10.5Z" fill="white"/>
              </svg>
              Template
            </button>
          </a>
            <button
            @click="openUploadModal(assessment.assessment_id)"
              class="bg-custom-blue text-white px-3 py-1 rounded  text-sm museo-sans-normal"
            >
              Upload Token
            </button>
          </div>
        </td>

        </tr>
      </tbody>
    </table>

    <div class="flex justify-center gap-4 mt-4">
      <button
          @click="previousPage"
          :disabled="pagination.current_page === 1"
          class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button">
        <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
             viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="m15 19-7-7 7-7"/>
        </svg>
        Previous
      </button>

      <div class="flex items-center gap-2">
        <button
            v-for="page in visiblePages"
            :key="page"
            @click="goToPage(page)"
            :class="{
            'bg-custom-blue text-white': page === pagination.current_page,
            'text-custom-blue': page !== pagination.current_page
          }"
            class="relative h-10 max-h-[40px] w-10 max-w-[40px] select-none rounded-lg text-center align-middle font-medium transition-all hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
            type="button">
          <span class="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">{{ page }}</span>
        </button>
      </div>

      <button
          @click="nextPage"
          :disabled="pagination.current_page === pagination.total_pages"
          class="flex items-center gap-2 px-6 py-3 font-bold text-center text-custom-blue align-middle transition-all rounded-lg select-none hover:bg-custom-blue/10 active:bg-custom-blue/20 disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none"
          type="button">
        Next
        <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
             viewBox="0 0 24 24">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m9 5 7 7-7 7"/>
        </svg>
      </button>
    </div>
</div>

<div v-if="isUploadModalOpen">
  <div class="fixed inset-0 bg-gray-900 bg-opacity-50 backdrop-blur-sm md:backdrop-blur flex justify-center items-center z-50">
    <div class="bg-white p-6 rounded-lg shadow-lg w-full max-w-5xl mx-4 max-h-[85vh] overflow-y-auto">
      <UploadTokensForm 
        :standalone="true" 
        :assessment-id="selectedCourseId"
        @close="closeUploadModal" 
      />
    </div>
  </div>
</div>

</template>

<script>
import { ref, onMounted, computed } from 'vue';
import { useToast } from 'vue-toastification';
import UploadTokensForm from '@/views/forms/UploadTokensForm.vue';
import api from '@/services/api';

export default {
  name: 'AdminUploadCpdTokens',
  components: {
    UploadTokensForm
  },
  setup() {
    const toast = useToast();
    const assessments = ref([]);
    const isUploadModalOpen = ref(false);
    const selectedCourseId = ref(null);
    /* removed router usage - we'll refresh data programmatically */
    const loading = ref(true);

    const pagination = ref({
      current_page: 1,
      total_pages: 1,
      per_page: 10,
      total_items: 0
    });
    const dashboardTotals = ref({
      total_uploaded: 0,
      total_awarded: 0,
      total_available: 0
    });


    const fetchAssessments = async (page = 1) => {
      try {
        loading.value = true;
        console.log('Fetching course tokens dashboard data for page:', page);
        const response = await api.getDashboardData({ page: page });
        console.log('Course tokens dashboard response:', response);
        
        // Handle the response structure
        const responseData = response.data || response;
        
        // Filter out courses with null or undefined cpd_points
        const filteredAssessments = (responseData.assessments || []).filter(
          (assessment) => assessment.cpd_points !== null && assessment.cpd_points !== undefined
        );

        assessments.value = filteredAssessments;
        pagination.value = responseData.meta || {current_page: 1, total_pages: 1, per_page: 10, total_items: 0};
        dashboardTotals.value = responseData.totals || {
          total_uploaded: 0,
          total_awarded: 0,
          total_available: 0
        };
        
        console.log('Updated pagination:', pagination.value);
        console.log('Updated assessments count:', assessments.value.length);
      } catch (error) {
        console.error('Error fetching course tokens dashboard:', error);
        toast.error('Failed to fetch course tokens data');
      } finally {
        loading.value = false;
      }
    };

    const openUploadModal = (courseId) => {
      selectedCourseId.value = courseId;
      isUploadModalOpen.value = true;
    };

    const closeUploadModal = () => {
      isUploadModalOpen.value = false;
      // Reload the document list after successful upload
      fetchAllData();
    };


    const goToPage = async (page) => {
      if (page >= 1 && page <= pagination.value.total_pages) {
        await fetchAssessments(page);
      }
    };

    const previousPage = async () => {
      if (pagination.value.current_page > 1) {
        await goToPage(pagination.value.current_page - 1);
      }
    };

    const nextPage = async () => {
      if (pagination.value.current_page < pagination.value.total_pages) {
        await goToPage(pagination.value.current_page + 1);
      }
    };

      const visiblePages = computed(() => {
      const pages = [];
      const totalPages = pagination.value.total_pages;
      const currentPage = pagination.value.current_page;

      // Display the current page and adjacent pages
      for (let i = Math.max(1, currentPage - 2); i <= Math.min(totalPages, currentPage + 2); i++) {
        pages.push(i);
      }
      return pages;
    });

    const fetchAllData = async () => {
      await fetchAssessments();
    };

    onMounted(async () => {
      await fetchAllData();
    });

    return {
      assessments,
      previousPage,
      nextPage,
      visiblePages,
      goToPage,
      pagination,
      isUploadModalOpen,
      selectedCourseId,
      openUploadModal,
      closeUploadModal,
      dashboardTotals,
      loading
    }

  }
};
</script>